module.exports = __webpack_public_path__ + "static/media/project-details.1fcb11ea.svg";